import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get ASYNC_COMPONENT() {
    return () => import('@/vue/pages/users/index_checker/urls/index.vue')
  }
}
